var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('router-link',{attrs:{"to":{ name: _vm.link }}},[_c('button',_vm._b({class:_vm.isInverted},'button',_vm.$attrs,false),[_vm._v(" "+_vm._s(_vm.text)+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }